var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE4\xBE\xA7\xE8\xBE\xB9\xE6\xA0\x8F/\xE5\x8E\xBB\xE5\xB1\x95\xE5\xBC\x80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0782 21.5982C20.5761 21.1003 20.5761 20.293 20.0782 19.7951L14.7564 14.4733L20.0782 9.15146C20.5761 8.65355 20.5761 7.84626 20.0782 7.34834C19.5803 6.85042 18.773 6.85042 18.2751 7.34834L12.0609 13.5626C11.8096 13.8139 11.6851 14.144 11.6875 14.4733C11.6851 14.8027 11.8096 15.1327 12.0609 15.384L18.2751 21.5982C18.773 22.0962 19.5803 22.0962 20.0782 21.5982Z",
    fill: "black",
    fillOpacity: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.6c7c40e4e85289bfcb809a5be52d57d8.svg";
export { ForwardRef as ReactComponent };